import React from "react";
import Layout from "../../layouts/index";
import TermsOfServicesScreen from "../../screens/onbording_web/TermsOfServices";

const TermsOfServices = () => {
  return (
    <Layout>
      <TermsOfServicesScreen />
    </Layout>
  );
};

export default TermsOfServices;
